import { render, staticRenderFns } from "./Subgroup.vue?vue&type=template&id=4eb0f327&scoped=true&"
import script from "./Subgroup.vue?vue&type=script&lang=js&"
export * from "./Subgroup.vue?vue&type=script&lang=js&"
import style0 from "./Subgroup.vue?vue&type=style&index=0&id=4eb0f327&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb0f327",
  null
  
)

export default component.exports